document.querySelectorAll(".tab-link").forEach(function (tab) {
  tab.addEventListener("click", function () {
    var tabId = this.dataset.tab;

    document.querySelectorAll(".tab-link").forEach(function (link) {
      link.classList.remove("current");
      link.style.backgroundColor = ""; // Reset background color
    });

    document.querySelectorAll(".tab-content").forEach(function (content) {
      content.classList.remove("current");
    });

    this.classList.add("current");
    this.style.backgroundColor = "#fff"; // Set active tab background color
    document.getElementById(tabId).classList.add("current");
  });
});
